"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDelimiter = exports.buildStringFromArrayItems = exports.buildCalendarBaseString = void 0;
var constants_1 = require("../../constants");
var formatters_1 = require("./formatters");
var index_1 = require("../index");
var buildCalendarBaseString = function (calendar) {
    var prodid = calendar.prodid, version = calendar.version, calscale = calendar.calscale, method = calendar.method;
    var result = '';
    result += constants_1.CALENDAR_BEGIN;
    // Add prodid
    result = (0, formatters_1.addKeyValue)(result, 'PRODID:', prodid);
    // Add version
    result = (0, formatters_1.addKeyValue)(result, 'VERSION:', version);
    if (method) {
        result = (0, formatters_1.addKeyValue)(result, 'METHOD:', method);
    }
    if (calscale) {
        result = (0, formatters_1.addKeyValue)(result, 'CALSCALE:', calscale);
    }
    return result;
};
exports.buildCalendarBaseString = buildCalendarBaseString;
var buildStringFromArrayItems = function (iCalString, items) {
    var result = iCalString;
    // Loop over all events
    if (items && items.length > 0) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            result = (0, index_1.buildString)(item, result);
        }
    }
    return result;
};
exports.buildStringFromArrayItems = buildStringFromArrayItems;
var getDelimiter = function (value) {
    var isValueArray = Array.isArray(value);
    return isValueArray ? ';' : ':';
};
exports.getDelimiter = getDelimiter;
